import { Button } from "react-admin"
import DescriptionIcon from '@mui/icons-material/Description';
import { downloadReport } from "../utils";

const ReportButton = () => {

    const handleReportButton = () => {
        downloadReport();
    };

    return (
        <Button label="Relatório Completo" onClick={handleReportButton}>
            <DescriptionIcon />
        </Button>
    )
}

export default ReportButton
